<script lang="ts">
  import { slide } from 'svelte/transition';

  import {
    CheckCircle, ExclamationCircle, InformationCircle, XCircle
  } from 'svelte-heros-v2';
  import type {SvelteComponent} from "svelte";
  import {type Toast, toasts, type ToastType} from "$lib/stores/toastStores";

  let toastList: Toast[] = $state([]);

  const unsubscribe = toasts.subscribe((value) => {
    toastList = value;
  });

  const typeClasses: Record<ToastType, string> = {
    success: 'bg-green-700',
    error: 'bg-red-700',
    info: 'bg-blue-900',
    warning: 'bg-gold-700',
  };

  const typeIcons: Record<ToastType, typeof SvelteComponent> | any = {
    success: CheckCircle,
    error: XCircle,
    info: InformationCircle,
    warning: ExclamationCircle,
  };
</script>

<div class="fixed top-4 left-1/2 transform -translate-x-1/2 md:top-4 md:right-4 md:left-auto md:transform-none z-[99] space-y-4" aria-live="polite">
  {#each toastList as toast (toast.id)}
    {@const SvelteComponent_1 = typeIcons[toast.type]}
    <div
      class="relative overflow-hidden flex items-center px-4 py-3 rounded-xl shadow-md text-white cursor-pointer border-primary-lightBlue/70 border-2 bg-primary-blue"
      onmouseenter={() => toasts.pause(toast.id)}
      onmouseleave={() => toasts.resume(toast.id)}
      onclick={() => {
        toasts.dismiss(toast.id)
        toast.onClick?.();
      }}
      in:slide={{ duration: 200 }}
      out:slide={{ duration: 200 }}
      role="alert">
      <SvelteComponent_1 class="w-6 h-6 mr-2 flex-shrink-0" />
      <div class="flex-1">
        {toast.message}
      </div>
      <div
        class="absolute bottom-0 left-0 h-1 transition-all"
        class:bg-green-300={toast.type === 'success'}
        class:bg-red-300={toast.type === 'error'}
        class:bg-blue-300={toast.type === 'info'}
        class:bg-yellow-300={toast.type === 'warning'}
        style="width: {100 * (toast.remaining / toast.duration)}%"></div>
    </div>
  {/each}
</div>
